import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-684beb7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-quick-audit-list" }
const _hoisted_2 = { style: {} }
const _hoisted_3 = {
  class: "xrk-alert xrk-alert--warning is-light",
  role: "alert"
}
const _hoisted_4 = { class: "xrk-icon xrk-alert__icon is-big" }
const _hoisted_5 = { class: "xrk-alert__content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "xrk-alert__title with-description",
  style: {"color":"#ff5252"}
}, " 审核要求 ", -1))
const _hoisted_7 = {
  class: "xrk-alert__description",
  style: {"color":"#ff5252"}
}
const _hoisted_8 = { style: {"margin":"10px","display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"5px"} }, "结果全选", -1))
const _hoisted_10 = { style: {"margin-right":"5px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"5px","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(220 56 34)"} }, "提示：*标记为"),
    /*#__PURE__*/_createElementVNode("img", {
      style: {"width":"20px","height":"20px"},
      src: "https://oss.myxrk.com/myxrk-v2/front-end/assets/oss/icon/2509011532.png"
    }),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(220 56 34)"} }, " 任务存在提交的图片存在重复，请注意查看 ")
  ])
], -1))

import { ref, computed, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';

import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton,
  XrkTableRef,
  BaseCheckbox,
  useCreateModal,
  BaseInput,
  BaseDatePicker,
  BaseSelect,
  BaseToolTip,
  BaseAutocomplete,
  BaseImage,
  XrkMessage,
  createDialog,
  BaseCascader,
  BaseIcon
} from 'xrk-components';
import { WarningFilled, Close, ArrowLeft } from '@element-plus/icons-vue';

import { formatter } from '@/utils/';
import { taskRiskPointsCol } from '@/common/fields/intelligent-audit';
import { useTaskAudit, useOpenTaskDetail } from '../hooks/useTaskAudit';
import SetDisplayInfo from '../components/set-display-info.vue';
import {
  quickAuditList,
  getTaskRecordIds,
  taskRecordUpdateMap,
  selectSimilartList,
  getProjectInfo
} from '../data-source/apis';
import { ProjectType } from '../types';
import { MAX_SELECT_LENGTH } from '../constants/index';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import RepeatPickure from '../components/repeat-pickure.vue';

import { FILE_VIEW_URL } from '@/config';
import DeefMap from '../components/deef-map.vue';
import appStore from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-quick-audit-list',
  setup(__props) {

const router = useRouter();
const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);
const xrkTableRef = ref<XrkTableRef>();

const tableDataRow = ref([]); //当前搜索条件下可勾选的id

const isSelectionAll = ref(false);

const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);

/**
 * 是否是服务商
 */
const isAsp = computed(() => defaultUserFnCode.value === 2);

// 勾选列表数据
const selectionRows = computed(() => {
  return xrkTableRef.value?.getSelectionRows() || [];
});
const isIndeterminate = computed(() => {
  if (selectionRows.value.length === 0) {
    return false;
  }
  return selectionRows.value.length !== tableDataRow.value.length;
});
const onSelectionAllChange = (val: boolean) => {
  if (val) {
    tableDataRow.value.forEach(item => {
      xrkTableRef.value.addSelectionRow(item, { id: item });
    });
  } else {
    xrkTableRef.value.clearSelectionRows();
  }
  isSelectionAll.value = val;
};

// 勾选列表数据变化时，更新全选状态
watch(
  () => selectionRows.value,
  val => {
    if (val.length === 0) {
      isSelectionAll.value = false;
      return;
    }
    isSelectionAll.value = val.length === tableDataRow.value.length;
  }
);

const projectType = computed<ProjectType>(() => {
  return projectInfo.value.sceneType;
});

const projectId = computed<number>(() => {
  return projectInfo.value.id;
});

//设置展示信息
const onSetDisplayInfo = () => {
  useCreateModal(SetDisplayInfo, {
    projectId: projectId.value,
    projectType: projectType.value,
    onConfirm() {
      nextTick(() => {
        setTableHeader();
        onRefreshTabel();
      });
    }
  });
};

const onRefreshTabel = () => {
  xrkTableRef.value?.initCurrentList();
  xrkTableRef.value?.clearSelectionRows();
};

const onBack = () => {
  router.back();
};

const onBatchAudit = status => {
  useTaskAudit({
    auditStatus: status,
    projectId: projectId.value,
    isBatch: true,
    queryParams: {
      sceneType: projectType.value,
      taskRecordId: xrkTableRef.value?.getSelectionRows().map(item => item.id)
    },
    auditOver() {
      xrkTableRef.value.clearSelectionRows();
      onRefreshTabel();
    }
  });
};

//文件预览
const onViewer = url => {
  window.open(`${FILE_VIEW_URL}?t=${Date.now()}&url=${url}`);
};

const limitToNum = data => {
  const num = data
    .replace(/[^\d.-]/g, '')
    //只允许一个小数点
    .replace(/^\./g, '')
    .replace(/\.{2,}/g, '.')
    //只能输入小数点后两位
    .replace('.', '$#$')
    .replace(/\./g, '')
    .replace('$#$', '.')
    // eslint-disable-next-line no-useless-escape
    .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
  return num;
};

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: false
  },
  resetBtn: {
    show: false
  },
  searchColumns: []
});

const listHeaderColumns = ref(null);
//表头
const getTableColumns = () => {
  const columns = [];
  const quickCheckedList = sessionStorage.getItem('quickCheckedList');
  listHeaderColumns.value = JSON.parse(quickCheckedList);
  //dataType
  //1：文本 2：时间 3：选择(不带value选择题) 4：图片地址 5：html地址
  //6：月度 7 :带value选择题 8 :数字填空题 -17 多级下拉框 -18时间段题

  // 每个题下边的备注
  const renderRemark = item => {
    return (
      <div>
        <BaseToolTip
          effect="dark"
          disabled={!item.remark}
          content={item.remark}
          placement="top"
        >
          <div
            class="ellipsis"
            style="text-align: left;color:#F56C6C;margin-top: 5px;height: 22px;"
          >
            {item.remark && (
              <>
                备注：
                <span>{item.remark}</span>
              </>
            )}
          </div>
        </BaseToolTip>
      </div>
    );
  };

  const renderTableHaderTxt = (item, length = 23) => {
    return (
      <BaseToolTip placement="top" effect="dark" content={item.label}>
        <div class=" render-hader-text">
          {item.label.length > length
            ? item.label.slice(0, length) + '...'
            : item.label}
        </div>
      </BaseToolTip>
    );
  };

  listHeaderColumns.value.forEach(item => {
    if ([1].includes(item.dataType)) {
      // 文本
      columns.push(
        useTableColumn({
          prop: item.prop,
          align: 'left',
          width: item?.prop === 'customerName' ? 500 : 210,
          renderHeader: () => {
            return (
              <>
                {renderTableHaderTxt(
                  item,
                  item?.prop === 'customerName' ? 65 : 23
                )}{' '}
                <div>
                  <BaseInput
                    style="width: 180px;"
                    v-model={item.conditionKey}
                    disabled={item.disable === 1}
                    placeholder="请输入内容"
                  />
                </div>
                {renderRemark(item)}
              </>
            );
          },
          formatter({ cellValue }) {
            if (item.prop === 'finishSumTaskPrice') {
              return formatter.fen2yuan(cellValue, '元');
            }
            return cellValue || (item.prop === 'userTag' ? '未设置' : '-');
          }
        })
      );
    } else if (item.dataType === 5) {
      // 附件带地址
      columns.push(
        useTableColumn({
          prop: item.prop,
          align: 'left',
          width: 210,
          renderHeader: () => {
            return (
              <>
                {renderTableHaderTxt(item)}
                <div>
                  <BaseInput
                    style="width: 180px;"
                    v-model={item.conditionKey}
                    disabled={item.disable === 1}
                    placeholder="请输入内容"
                  />
                </div>
                {renderRemark(item)}
              </>
            );
          },
          render({ cellValue }) {
            let _cellValue = cellValue;
            try {
              _cellValue = JSON.parse(cellValue);
            } catch (error) {
              //
            }
            return (
              <>
                <BaseButton
                  disabled={!cellValue || !_cellValue?.url}
                  type="text"
                  onClick={() => {
                    onViewer(_cellValue?.url);
                  }}
                >
                  {_cellValue?.name || '-'}
                </BaseButton>
              </>
            );
          }
        })
      );
    } else if (item.dataType === 8) {
      //dataType:8 数字填空题 为区间
      columns.push(
        useTableColumn({
          prop: item.prop,
          align: 'left',
          width: 210,
          renderHeader: () => {
            return (
              <>
                {renderTableHaderTxt(item)}
                <div style="display: flex;align-items: center;">
                  <BaseInput
                    style="width: 73px;"
                    v-model={item.conditionKey[0]}
                    disabled={item.disable === 1}
                    placeholder="请输入内容"
                    onFocus={() => {
                      item.conditionKey = Array.isArray(item.conditionKey)
                        ? item.conditionKey
                        : ['', ''];
                    }}
                    onInput={e => {
                      item.conditionKey[0] = limitToNum(e);
                    }}
                  />
                  <span style="font-size: 10px; margin: 0 5px">—</span>
                  <BaseInput
                    style="width: 73px;"
                    v-model={item.conditionKey[1]}
                    disabled={item.disable === 1}
                    placeholder="请输入内容"
                    onFocus={() => {
                      item.conditionKey = Array.isArray(item.conditionKey)
                        ? item.conditionKey
                        : ['', ''];
                    }}
                    onInput={e => {
                      item.conditionKey[1] = limitToNum(e);
                    }}
                  />
                </div>
                {renderRemark(item)}
              </>
            );
          }
        })
      );
    } else if (item.dataType === 2) {
      //时间日期选择题
      columns.push(
        useTableColumn({
          prop: item.prop,
          align: 'left',
          width: 270,
          renderHeader: () => {
            return (
              <>
                {renderTableHaderTxt(item)}
                <div>
                  <BaseDatePicker
                    style="width: 260px;"
                    v-model={item.conditionKey}
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  />
                </div>
                {renderRemark(item)}
              </>
            );
          },
          formatter({ cellValue }) {
            return formatter.date(+cellValue);
          }
        })
      );
    } else if (item.dataType === 18) {
      //时间段题
      columns.push(
        useTableColumn({
          prop: item.prop,
          align: 'left',
          width: 320,
          renderHeader: () => {
            return (
              <>
                {renderTableHaderTxt(item)}
                <div>
                  <BaseDatePicker
                    style="width: 260px;"
                    v-model={item.conditionKey}
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  />
                </div>
                {renderRemark(item)}
              </>
            );
          },
          formatter({ cellValue }) {
            if (!cellValue) {
              return '-';
            }
            const _cellValue = JSON.parse(cellValue);
            return `${_cellValue.startAt}-${_cellValue.endAt}`;
          }
        })
      );
    } else if (item.dataType === 6) {
      //月度选择题
      columns.push(
        useTableColumn({
          prop: item.prop,
          align: 'left',
          width: 210,
          renderHeader: () => {
            return (
              <>
                {renderTableHaderTxt(item)}
                <div>
                  <BaseDatePicker
                    style="width: 180px;"
                    v-model={item.conditionKey}
                    type="monthrange"
                    value-format="YYYY-MM"
                    range-separator="至"
                    start-placeholder="开始月份"
                    end-placeholder="结束月份"
                  />
                </div>
                {renderRemark(item)}
              </>
            );
          },
          formatter({ cellValue }) {
            return formatter.date(+cellValue, 'YYYY-MM');
          }
        })
      );
    } else if ([3, 7].includes(item.dataType)) {
      //选择题
      columns.push(
        useTableColumn({
          prop: item.prop,
          align: 'left',
          width: 210,
          renderHeader: () => {
            return (
              <>
                {renderTableHaderTxt(item)}
                <div>
                  <BaseSelect
                    style="width: 180px;"
                    v-model={item.conditionKey}
                    placeholder="请选择"
                    clearable
                    filterable
                    collapse-tags
                    options={item.options.map(citem => {
                      return {
                        label: citem.label ? citem.label : citem,
                        value: citem.value ? citem.value : citem
                      };
                    })}
                  ></BaseSelect>
                </div>
                {renderRemark(item)}
              </>
            );
          },
          render(data) {
            const { cellValue } = data;
            if (item.prop === 'riskPoints') {
              return taskRiskPointsCol.render(data);
            }
            const setOptions = (options, prop) => {
              const cell = options.filter(item => {
                return +item.value === prop;
              });
              return cell[0].label || '-';
            };
            return (
              <div>
                {item.dataType === 7
                  ? setOptions(item.options, cellValue)
                  : cellValue || '-'}
              </div>
            );
          }
        })
      );
    } else if ([17].includes(item.dataType)) {
      //多级下拉框
      columns.push(
        useTableColumn({
          prop: item.prop,
          align: 'left',
          width: 210,
          renderHeader: () => {
            return (
              <>
                {renderTableHaderTxt(item)}
                <div>
                  <BaseCascader
                    style="width: 180px;"
                    v-model={item.conditionKey}
                    placeholder="请选择"
                    clearable
                    filterable
                    collapse-tags
                    options={item.options}
                  ></BaseCascader>
                </div>
                {renderRemark(item)}
              </>
            );
          },
          render({ cellValue }) {
            const setValues = cellValue => {
              if (cellValue) {
                return JSON.parse(cellValue)
                  .map(item => item.label)
                  .join('/');
              }
              return '-';
            };
            return <div>{setValues(cellValue)}</div>;
          }
        })
      );
    } else if (item.dataType === 31) {
      //人员标签
      columns.push(
        useTableColumn({
          prop: item.prop,
          align: 'left',
          width: 210,
          renderHeader: () => {
            return (
              <>
                {renderTableHaderTxt(item)}
                <div>
                  <BaseAutocomplete
                    placeholder="人员标签"
                    maxlength="30"
                    style="width: 180px;"
                    v-model={item.conditionKey}
                    fetch-suggestions={(queryString, cb) => {
                      cb(
                        item.options.filter(
                          i =>
                            !queryString || i.value?.indexOf(queryString) > -1
                        )
                      );
                    }}
                  ></BaseAutocomplete>
                </div>
                {renderRemark(item)}
              </>
            );
          },
          formatter({ cellValue }) {
            return cellValue || (item.prop === 'userTag' ? '未设置' : '-');
          }
        })
      );
    } else if ([4, 9, 16].includes(item.dataType)) {
      //可放大图片【图片/定位 题型】
      columns.push(
        useTableColumn({
          prop: item.prop,
          align: 'left',
          width: 210,
          renderHeader: () => {
            return (
              <>
                {renderTableHaderTxt(item)}
                <div>
                  <BaseInput
                    style="width: 180px;"
                    v-model={item.conditionKey}
                    disabled={true}
                    placeholder="请输入内容"
                  />
                </div>
                {renderRemark(item)}
              </>
            );
          },
          render: ({ cellValue, row }) => {
            let newUrl = cellValue;
            try {
              newUrl = newUrl.split(',');
            } catch (error) {
              newUrl = [newUrl];
            }

            return (
              <>
                <div>
                  {cellValue ? (
                    <div style="display: flex;align-items: flex-end;">
                      {newUrl.map((src, index) => {
                        return (
                          <BaseImage
                            previewTeleported={true}
                            key={src}
                            src={src}
                            preview-src-list={newUrl}
                            initial-index={index}
                            style={{
                              width: '60px',
                              height: '60px',
                              marginRight: '5px'
                            }}
                          />
                        );
                      })}
                      {(item.dataType === 9 || item.topicType === 16) && (
                        <>
                          <BaseButton
                            style="margin-left:10px;color:#0B6623"
                            onClick={async () => {
                              const { data } = await taskRecordUpdateMap({
                                taskRecordId: row.id,
                                projectId: projectId.value,
                                sceneType: projectType.value
                              });
                              row[item.prop] = data;
                            }}
                            type="text"
                          >
                            更新
                            <br />
                            地图
                          </BaseButton>
                          <BaseButton
                            onClick={async () => {
                              createDialog({
                                width: 1200,
                                appendToBody: true,
                                title: '对比地图',
                                showClose: true,
                                contentRender: done => {
                                  return (
                                    <>
                                      <div style="position: relative;height: 600px;">
                                        <DeefMap
                                          projectType={projectType.value}
                                          projectId={projectId.value}
                                          taskRecordId={row.id}
                                          dataState={0}
                                          done={done}
                                        />
                                      </div>
                                    </>
                                  );
                                }
                              });
                            }}
                            type="text"
                          >
                            对比
                            <br />
                            地图
                          </BaseButton>
                        </>
                      )}
                    </div>
                  ) : (
                    '-'
                  )}
                </div>
              </>
            );
          }
        })
      );
    }
  });
  return [...columns];
};

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [],
  baseConfig: {
    onSortChange: data => {
      const prop = String(data.prop); // 显式转换为字符串
      const order = String(data.order) === 'null' ? '' : String(data.order); // 显式转换为字符串
      xrkTableRef.value.setSearchValue(`${prop}Order`, order);
      xrkTableRef.value.initCurrentList();
    },
    onSelect(selection: any, row: any) {
      if (selection.length > MAX_SELECT_LENGTH) {
        XrkMessage.warning('最多只能选择' + MAX_SELECT_LENGTH + '条数据');
        xrkTableRef.value.removeSelectionRow(row.id);
      }
    },
    onSelectAll(selection) {
      if (selection.length > MAX_SELECT_LENGTH) {
        // 获取selection超过MAX_SELECT_LENGTH个的时候，清除多余的selection
        selection.slice(MAX_SELECT_LENGTH).forEach((item: any) => {
          XrkMessage.warning('最多只能选择' + MAX_SELECT_LENGTH + '条数据');
          xrkTableRef.value.removeSelectionRow(item.id);
        });
      }
    }
  }
});

/**
 * 查看任务详情
 * @param id
 */
const onTaskDetail = async (id: number) => {
  useOpenTaskDetail({
    id,
    projectType: projectType.value,
    projectId: projectId.value,
    canAudit: true,
    xrkTableRef,
    dataState: 0
  });
};
const repeatPickurePerview = (row, similarTaskIdList) => {
  createDialog({
    width: 1500,
    title: '图片重复关联项目',
    showClose: true,
    contentRender: () => {
      return (
        <div style="padding: 20px;">
          <RepeatPickure
            projectId={projectId.value}
            taskId={row.id}
            similarTaskIdList={similarTaskIdList}
          ></RepeatPickure>
        </div>
      );
    },
    beforeConfirm: async done => {
      done();
    }
  });
};
const setTableHeader = () => {
  tableConfig.value.tableColumns = [
    useTableColumn({
      type: '_selection',
      prop: 'id',
      align: 'center',
      fixed: 'left',
      width: 60
    }),
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '65px',
      fixed: 'left',
      render: ({ row, index }) => {
        const hasRepeatPicIds = Object.keys(repitImgList.value);
        const isHasRepeatPic = hasRepeatPicIds.includes(String(row.id));
        return (
          <div>
            {isHasRepeatPic && (
              <img
                src="https://oss.myxrk.com/myxrk-v2/front-end/assets/oss/icon/2509011532.png"
                style="cursor:pointer;width:20px;"
                onClick={() => {
                  repeatPickurePerview(row, repitImgList.value[row.id]);
                }}
                type="text"
              />
            )}
            <span>{index + 1}</span>
          </div>
        );
      }
    }),
    ...getTableColumns(),
    useTableColumn({
      align: 'left',
      fixed: 'right',
      width: 210,
      renderHeader: () => {
        return (
          <>
            <div>操作</div>
            <div>
              <BaseButton
                onClick={() => {
                  onRefreshTabel();
                }}
                type="text"
              >
                搜索
              </BaseButton>
              <BaseButton
                onClick={() => {
                  listHeaderColumns.value.forEach(item => {
                    item.conditionKey = '';
                  });
                  onRefreshTabel();
                }}
                type="text"
              >
                重置
              </BaseButton>
            </div>
          </>
        );
      },
      render({ row }) {
        return (
          <>
            <div>
              <BaseButton
                onClick={() => {
                  onTaskDetail(row.id);
                }}
                type="text"
              >
                查看
              </BaseButton>
              <BaseButton
                onClick={() => {
                  useTaskAudit({
                    auditStatus: 2,
                    projectId: projectId.value,
                    queryParams: {
                      sceneType: projectType.value,
                      taskRecordId: [row.id]
                    },
                    auditOver() {
                      xrkTableRef.value.clearSelectionRows();
                      onRefreshTabel();
                    }
                  });
                }}
                type="text"
              >
                通过
              </BaseButton>
              <BaseButton
                onClick={() => {
                  useTaskAudit({
                    auditStatus: 3,
                    projectId: projectId.value,
                    queryParams: {
                      sceneType: projectType.value,
                      taskRecordId: [row.id]
                    },
                    auditOver() {
                      xrkTableRef.value.clearSelectionRows();
                      onRefreshTabel();
                    }
                  });
                }}
                type="text"
              >
                不通过
              </BaseButton>
            </div>
          </>
        );
      }
    })
  ];
};
//设置表头
setTableHeader();

// 传给后端的搜索条件
const setConditions = () => {
  return listHeaderColumns.value.map(item => {
    //将区间搜索里的array转化成string如果为['','']则转化为''
    let dataValue = item.conditionKey;
    if (Array.isArray(dataValue)) {
      dataValue = dataValue.join(',');
    }
    dataValue = dataValue === ',' ? '' : dataValue;
    //金额搜索时转化
    if (item.prop === 'finishSumTaskPrice') {
      dataValue = +dataValue * 100;
    }
    //人员标签搜索有未设置选项
    if (item.prop === 'userTag' && item.conditionKey === '未设置') {
      xrkTableRef.value.setSearchValue(`notSet`, 1);
    } else {
      xrkTableRef.value.setSearchValue(`notSet`, 0);
    }
    return {
      key: item.prop,
      value: dataValue || '',
      isTopic: item.isTopic,
      topicType: item.topicType
    };
  });
};
const pageTableData = ref([]); // 当前列表数据

// 重复图片列表
const repitImgList = ref({});

const hasRepeatPic = computed(() => {
  // 当前是否有重复图片
  return Object.keys(repitImgList.value).length > 0;
});
const getRepitImgList = () => {
  nextTick(async () => {
    const { data } = await selectSimilartList({
      projectId: projectId.value,
      taskIdList: pageTableData.value.map(i => i.id)
    });
    repitImgList.value = data || {};
  });
};
// 获取当前搜索条件下可勾选的id集合
const getRecordIds = async params => {
  const { data } = await getTaskRecordIds(params, 'quick');
  tableDataRow.value = data || [];
};

const ajaxProjectInfo = ref<{ projectRequire: string }>({
  projectRequire: ''
});
const showProjectRequireBtn = computed(() => {
  return !!ajaxProjectInfo.value.projectRequire;
});
const showProjectRequire = ref(false);
const onGetAuditRequire = e => {
  showProjectRequire.value = e;
};

const onGetAjaxProjectInfo = async () => {
  const { data: projectInfo } = await getProjectInfo({
    projectId: projectId.value
  });
  ajaxProjectInfo.value = projectInfo;
  showProjectRequire.value = !!ajaxProjectInfo.value.projectRequire;
};
onGetAjaxProjectInfo();
const getListAjax = async params => {
  isAsp.value &&
    getRecordIds({
      pageNum: 1,
      pageSize: 2000,
      sceneType: projectType.value,
      projectId: projectId.value,
      conditions: setConditions()
    });
  const data = await quickAuditList({
    ...params,
    sceneType: projectType.value,
    projectId: projectId.value,
    conditions: setConditions()
  });
  pageTableData.value = data.data.list;

  isAsp.value && getRepitImgList();
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseButton), {
      link: "",
      icon: _unref(ArrowLeft),
      onClick: onBack
    }, {
      default: _withCtx(() => [
        _createTextVNode("返回")
      ]),
      _: 1
    }, 8, ["icon"]),
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value,
      style: {"max-height":"740px"}
    }, _createSlots({
      tableBefore: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("i", _hoisted_4, [
                _createVNode(_unref(BaseIcon), {
                  class: "contract",
                  color: "#ff5252"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(WarningFilled))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("p", _hoisted_7, _toDisplayString(ajaxProjectInfo.value.projectRequire), 1),
                _createElementVNode("i", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onGetAuditRequire(false))),
                  class: "xrk-icon xrk-alert__close-btn"
                }, [
                  _createVNode(_unref(BaseIcon), {
                    style: {"color":"#898989"},
                    size: "16"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Close))
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, ajaxProjectInfo.value.projectRequire && showProjectRequire.value]
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _createVNode(_unref(BaseCheckbox), {
              indeterminate: isIndeterminate.value,
              modelValue: isSelectionAll.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isSelectionAll).value = $event)),
              onChange: onSelectionAllChange
            }, null, 8, ["indeterminate", "modelValue"]),
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, " 已选" + _toDisplayString(selectionRows.value.length) + "条，批量操作 ", 1),
            _createVNode(_unref(BaseButton), {
              type: "default",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (onBatchAudit(2)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 批量通过 ")
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseButton), {
              type: "default",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (onBatchAudit(3)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 批量驳回 ")
              ]),
              _: 1
            }),
            (showProjectRequireBtn.value)
              ? (_openBlock(), _createBlock(_unref(BaseButton), {
                  key: 0,
                  type: "default",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (onGetAuditRequire(true)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 查看审核要求 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(BaseButton), {
              type: "default",
              onClick: onSetDisplayInfo
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 设置展示信息 ")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 2
    }, [
      (isAsp.value && hasRepeatPic.value)
        ? {
            name: "tableAfter",
            fn: _withCtx(() => [
              _hoisted_11
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["searchConfig", "tableConfig"])
  ]))
}
}

})